import { PageHeader } from '@/components/PageHeader';
import { ProcessingAnalyticsDashboard } from '@/components/ProcessingAnalyticsDashboard';
import { ErrorRecoveryPanel } from '@/components/ErrorRecoveryPanel';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

export default function ProcessingAnalytics() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Processing Analytics & Recovery"
        description="Advanced analytics, monitoring, and error recovery for bill processing"
      />
      
      <Tabs defaultValue="analytics" className="space-y-6">
        <TabsList>
          <TabsTrigger value="analytics">Analytics Dashboard</TabsTrigger>
          <TabsTrigger value="recovery">Error Recovery</TabsTrigger>
        </TabsList>
        
        <TabsContent value="analytics">
          <ProcessingAnalyticsDashboard />
        </TabsContent>
        
        <TabsContent value="recovery">
          <ErrorRecoveryPanel />
        </TabsContent>
      </Tabs>
    </div>
  );
}